import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

// Zone tab — READ-ONLY. Shows the current zone as a single big orange number, front-and-centre.
// Deliberately "breaks the vending machine": no Run button, no inputs, no cards.
//
// CR-20260904-001, Zones Z7 (contract C4): it now renders the live value the host reads from
// GetPortfolioCurrentZoneData for the selected portfolio. The 7500 placeholder is gone. A null
// value renders N/A — a portfolio with no assigned template, or with no zone picked yet, has no
// zone, and showing a stale number from the previously selected portfolio would be worse than
// showing nothing.
@Component({
    selector: 'ets-apg-zone-panel',
    templateUrl: './apg-zone-panel.component.html',
    styleUrls: ['./apg-zone-panel.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ApgZonePanelComponent {
    // The live current-zone value for the selected portfolio. null = N/A.
    @Input() currentZone: number | null = null;

    get displayZone(): string {
        return this.currentZone === null || this.currentZone === undefined
            ? 'N/A'
            : '' + this.currentZone;
    }
}
